import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from '@framework/router';
import LinkTable from '@/creditflowresearch/ui/common/components/LinkTable';
import { useLeagueTableContext } from '@/creditflowresearch/application/League/Table/LeagueTableContext';
import { useLeagueTableFiltersContext } from '@/creditflowresearch/application/League/Table/LeagueTableFiltersContext';

const TopRatingAgencies = (props) => {
  const { query: { products, regions } } = useRouter();
  const {
    state: leagueTableState,
    paginateTopRatingAgencies,
    getTopRatingAgenciesByFilter,
    resetTopRatingAgencies,
  } = useLeagueTableContext();
  const { state: filtersState } = useLeagueTableFiltersContext();
  const { page, perPage } = leagueTableState.topRatingAgenciesCollection;
  const didMount = useRef(false);
  const selectedPeriod = filtersState.periods.topRatingAgencies.selected;

  const [isPagesReset, setIsPagesReset] = useState(false);

  const onPageChange = (page) => {
    paginateTopRatingAgencies(page.selected);
  };

  useEffect(() => () => {
    resetTopRatingAgencies();
  }, []);

  useEffect(() => {
    if (didMount.current) {
      getTopRatingAgenciesByFilter();
    }
  }, [perPage, page]);

  useEffect(() => {
    if (didMount.current) {
      paginateTopRatingAgencies(1);
      setIsPagesReset(true);
    } else {
      didMount.current = true;
    }
  }, [selectedPeriod, products, regions]);

  useEffect(() => {
    if (isPagesReset) {
      getTopRatingAgenciesByFilter();
      setIsPagesReset(false);
    }
  }, [isPagesReset]);

  return (
    <LinkTable
      { ...props }
      { ...leagueTableState.topRatingAgenciesCollection }
      onPageChange={ onPageChange }
      dataTest="topRatingAgenciesLeagueTable"
    />
  );
};

export default TopRatingAgencies;
